import { Blockquote, Inset } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";
import Y2024M01 from "../Events/Y2024M01";
import Y2024M03D24 from "../Events/Y2024M03D24";
import Y2024M03D20 from "../Events/Y2024M03D20";
import Y2024M04 from "../Events/Y2024M04";
import Y2024M07 from "../Events/Y2024M07";
import Y2024M09 from "../Events/Y2024M09";
import Y2024M09D27 from "../Events/Y2024M09D27";
import Y2024M10 from "../Events/Y2024M10";
import Y2024M04D08 from "../Events/Y2024M04D08";
import Y2025M03D28 from "../Events/Y2025M03D28";
import Y2025M05 from "../Events/Y2025M05";
import Y2025M09 from "../Events/Y2025M09";
import Y2025M09a from "../Events/Y2025M09a";
import Y2025M10 from "../Events/Y2025M10";
import Y2025M11D08 from "../Events/Y2025M11D08";
import Y2025M11D14 from "../Events/Y2025M11D14";
import Y2026M01 from "../Events/Y2026M01";
import Y2026M03D27 from "../Events/Y2026M03D27";
import Y2026M05D08 from "../Events/Y2026M05D08";

export default function Events() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container py-3">
        <div className='row py-3'>
          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-events.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '40%',
                  height: '40%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
            </Inset>
          </div>
          <div className='col-lg-8'>
            <Blockquote size="8" color>
              Events
            </Blockquote>
          </div>
        </div>

        <div className='row pb-3'>
          <Y2026M05D08 />
        </div>

        <div className='row pb-3'>
          <Y2026M03D27 />
        </div>

        <div className='row pb-3'>
          <Y2026M01 />
        </div>

        <div className='row pb-3'>
          <Y2025M11D14 />
        </div>

        <div className='row pb-3'>
          <Y2025M11D08 />
        </div>

        <div className='row pb-3'>
          <Y2025M10 />
        </div>

        <div className='row pb-3'>
          <Y2025M09a />
        </div>

        <div className='row pb-3'>
          <Y2025M09 />
        </div>

        <div className='row pb-3'>
          <Y2025M05 />
        </div>

        <div className='row pb-3'>
          <Y2025M03D28 />
        </div>

        <div className='row pb-3'>
          <Y2024M10 />
        </div>

        <div className='row pb-3'>
          <Y2024M09D27 />
        </div>

        <div className='row pb-3'>
          <Y2024M09 />
        </div>

        <div className='row pb-3'>
          <Y2024M07 />
        </div>

        <div className='row pb-3'>
          <Y2024M04 />
        </div>

        <div className='row pb-3'>
          <Y2024M04D08 />
        </div>

        <div className='row pb-3'>
          <Y2024M03D20 />
        </div>

        <div className='row pb-3'>
          <Y2024M03D24 />
        </div>

        <div className='row pb-3'>
          <Y2024M01 />
        </div>

      </div>

      <AddBottomSpace />
    </>
  )
}
